var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,style:('grid-row: ' + _vm.row + '; grid-column: ' + _vm.column + ';')},[_vm._v("\n  "+_vm._s(_vm.stock)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }